
import { Component, Vue } from 'vue-property-decorator'
import WhitelabelDetail from '@/components/whitelabel/WhitelabelDetail.vue'
import authModule from '@/store/auth'

@Component({
  name: 'Whitelabel',
  components: { WhitelabelDetail }
})
class Whitelabel extends Vue {
  private created(): void {
    if (authModule.isPartner) {
      this.$router.replace({ name: 'Home' })
    }
  }
}

export default Whitelabel
